import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import headerimg from '../assets/startup.svg';
import { Link } from 'react-scroll';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const Home = () => {
	useEffect(() => {
		Aos.init({ duration: 3000 });
	}, []);
	return (
		<div name="home" className="h-screen w-full bg-[#0a192f]">
			<div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
				<div className="flex flex-col justify-center h-full">
					<h2 className="text-4xl sm:text-7xl font-bold text-white">
						Welcome!
					</h2>
					<p className="text-gray-500 py-4 max-w-md">
						I have a passion for coding, problem solving and learning new
						technologies. I finished bootcamp of Web Development, where I
						learned about front-end development. Currently I am studying at
						University of Suffolk, BSc(Hons) - Computer Science.
					</p>
					<div>
						<Link
							to="about"
							smooth
							duration={500}
							className="h-div group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
						>
							About Me
							<span className="group-hover:rotate-90 duration-300">
								<HiArrowNarrowRight size={25} className="ml-3" />
							</span>
						</Link>
					</div>
				</div>
				<div>
					<img
						src={headerimg}
						alt="header-img"
						className="hdr-img rounded-2xl mx-auto w-2/3 md:w-full"
					/>
				</div>
			</div>
		</div>
	);
};
export default Home;
